module.exports = __webpack_public_path__ + "static/media/coxsBazar.c530f679.png";